import BillingIcon from '@/components/icons/navigations/BillingIcon.vue'
import SecurityIcon from '@/components/icons/navigations/SecurityIcon.vue'
import LogoutIcon from '@/components/icons/LogoutIcon.vue'
import UserIcon from '@/components/icons/navigations/UserIcon.vue'
import AccountSettingsIcon from '@/components/icons/navigations/AccountSettingsIcon.vue'
import NotificationIcon from '@/components/icons/navigations/NotificationIcon.vue'

import { ROUTES } from '@/constants/routes'
import { ROUTER_PARAMS_NAMES } from '@/constants/routerParamsNames'
import { NAVIGATION_ACTIONS } from '@/constants/navigationActions'

const userSetting = {
    id: 1,
    name: 'Profile',
    routeName: ROUTES.userSetting,
    icon: () => UserIcon,
}

const notificationSettings = {
    id: 2,
    name: 'Notification Settings',
    routeName: ROUTES.notificationSettings,
    icon: () => NotificationIcon,
}

const accountSetting = {
    id: 4,
    name: 'Account Settings',
    icon: () => AccountSettingsIcon,
    isOpenSub: false,
    isFirstLoad: true,
    subMenu: [
        {
            name: 'Account',
            routeName: ROUTES.accountSetting,
            paramsNames: [ROUTER_PARAMS_NAMES.account],
        },
    ],
}

const securityForWorkspaceOwner = {
    id: 5,
    name: 'Security',
    icon: () => SecurityIcon,
    isOpenSub: false,
    isFirstLoad: true,
    subMenu: [
        {
            name: 'Password',
            routeName: ROUTES.password,
        },
        {
            name: 'Login Security',
            routeName: ROUTES.loginSecurity,
        },
        {
            name: 'Two-Factor Auth',
            routeName: ROUTES.twoFactorAuth,
        },
        {
            name: 'Protection',
            routeName: ROUTES.protection,
            paramsNames: [ROUTER_PARAMS_NAMES.account],
        },
        {
            name: 'API-Token',
            routeName: ROUTES.apiAccessTokens,
            paramsNames: [ROUTER_PARAMS_NAMES.account],
        },
        {
            name: 'Workspace Activity',
            routeName: ROUTES.workspaceActivity,
            paramsNames: [ROUTER_PARAMS_NAMES.workspace],
        },
    ],
}

const securityForGuest = {
    id: 3,
    name: 'Security',
    icon: () => SecurityIcon,
    isOpenSub: false,
    isFirstLoad: true,
    subMenu: [
        {
            name: 'Password',
            routeName: ROUTES.password,
        },
        {
            name: 'Login Security',
            routeName: ROUTES.loginSecurity,
        },
        {
            name: 'Two-Factor Auth',
            routeName: ROUTES.twoFactorAuth,
        },
    ],
}

const billingForWorkspaceOwner = {
    id: 6,
    name: 'Billing',
    icon: () => BillingIcon,
    isOpenSub: false,
    isFirstLoad: true,
    subMenu: [
        {
            name: 'Manage Billing',
            routeName: ROUTES.manageBilling,
            paramsNames: [ROUTER_PARAMS_NAMES.workspace],
        },
        {
            name: 'Rates and Expenses',
            routeName: ROUTES.ratesExpenses,
            paramsNames: [ROUTER_PARAMS_NAMES.account],
        },
    ],
}

const billingForGuest = {
    id: 6,
    name: 'Billing',
    icon: () => BillingIcon,
    isOpenSub: false,
    isFirstLoad: true,
    subMenu: [
        {
            name: 'Manage Billing',
            routeName: ROUTES.manageBilling,
            paramsNames: [ROUTER_PARAMS_NAMES.workspace],
        },
    ],
}

const logout = {
    id: 5,
    name: 'Logout',
    action: NAVIGATION_ACTIONS.logout,
    icon: () => LogoutIcon,
}

export const SETTINGS_MENU_ROUTES_WORKSPACE_OWNER = [
    userSetting,
    notificationSettings,
    accountSetting,
    securityForWorkspaceOwner,
    billingForWorkspaceOwner,
    logout,
]

export const SETTINGS_MENU_ROUTES_WITH_BILLING = [
    userSetting,
    notificationSettings,
    securityForGuest,
    billingForGuest,
    logout,
]

export const SETTINGS_MENU_ROUTES_WITHOUT_BILLING = [
    userSetting,
    notificationSettings,
    securityForGuest,
    logout,
]
